import { atom } from "jotai";
import { graphql, readInlineData } from "react-relay";

import type { atomsCurrentArticleAtomBase$key } from "scmp-app/queries/__generated__/atomsCurrentArticleAtomBase.graphql";
import type { atomsCurrentShareContentAtomBase$key } from "scmp-app/queries/__generated__/atomsCurrentShareContentAtomBase.graphql";
import type { hooksTrackCurrentItemBase$data } from "scmp-app/queries/__generated__/hooksTrackCurrentItemBase.graphql";

export const currentItemAtom = atom<hooksTrackCurrentItemBase$data | null>(null);

export const currentArticleAtom = atom(get => {
  const currentItem = get(currentItemAtom);
  if (!currentItem) return;

  const item = readInlineData<atomsCurrentArticleAtomBase$key>(
    graphql`
      fragment atomsCurrentArticleAtomBase on BaseWithApplicationAndUrlAlias
      @inline
      @argumentDefinitions(
        customContents: { type: "[CustomContentInput]", defaultValue: [] }
        bodyType: { type: "BodyFormatTypeEnum", defaultValue: PARAGRAPH }
      ) {
        __typename
        ... on Content {
          ...articleHeadlineHeaderFeaturesContent
          ...articleSeoArticle @arguments(customContents: $customContents, bodyType: $bodyType)
          ...articleShareWidgetArticle
          ...bookmarkHeaderFeaturesContent
          ...commentHeaderFeaturesArticle
          ...contentShareWidgetContent
          ...commentHeaderFeaturesArticle
          ...helpersCheckIsStyleArticle
          ...helpersUseSharingUrl
          ...hooksContentInterestArticle
          ...hooksTrackPageViewArticle
          ...hooksUseCurrentArticleIdsArticle
          ...hooksUseCurrentArticlePrebidConfigArticle
          ...hooksUsePageTargetingArticle
          ...onboardingNewsletterSubscriptionArticle
          ...entityLinkHeaderFeaturesArticle
          ...shareHeaderFeaturesContent
          ...helpersRosettaArticleContextArticle
        }
      }
    `,
    currentItem,
  );

  switch (item.__typename) {
    case "%other":
      return;
    case "Article":
      return item;
    case "Video":
      return item;
  }
});

export const currentShareContentAtom = atom(get => {
  const currentItem = get(currentItemAtom);
  if (!currentItem) return;

  const item = readInlineData<atomsCurrentShareContentAtomBase$key>(
    graphql`
      fragment atomsCurrentShareContentAtomBase on BaseWithApplicationAndUrlAlias @inline {
        __typename
        ... on Article {
          ...contentShareWidgetContent
        }
        ... on Video {
          ...contentShareWidgetContent
        }
      }
    `,
    currentItem,
  );

  switch (item.__typename) {
    case "%other":
      return;
    case "Article":
    case "Video":
      return item;
  }
});
